/**
 * Greeting variants API Service (KAN-651): варианты-брифы первого сообщения Telegram-аутрича.
 *
 *   GET    /api/v1/telegram/greeting-variants/?operator_id=   - KAN-752: варианты оператора
 *   POST   /api/v1/telegram/greeting-variants/                - {brief, enabled?, operator_id?}
 *   PATCH  /api/v1/telegram/greeting-variants/{id}/           - {brief?, enabled?}
 *   DELETE /api/v1/telegram/greeting-variants/{id}/
 *   POST   /api/v1/telegram/greeting-variants/{id}/generate/  - {n}
 *   PATCH  /api/v1/telegram/greeting-texts/{id}/              - {text?, enabled?}
 *   DELETE /api/v1/telegram/greeting-texts/{id}/
 */
import apiClient from './client';

export interface GreetingText {
  id: number;
  variant_id: number;
  text: string;
  enabled: boolean;
  sent_count: number;
  created_at: string | null;
}

export interface GreetingVariant {
  id: number;
  ab_key: string;
  label: string;
  brief: string;
  enabled: boolean;
  operator_id: string;
  operator_email: string;
  created_at: string | null;
  texts: GreetingText[];
  texts_enabled: number;
}

export interface GenerateResult {
  created: number;
  variant: GreetingVariant;
}

const BASE = '/api/v1/telegram/greeting-variants/';
/** Генерация идёт синхронно: ждём дольше обычного запроса. */
const GENERATE_TIMEOUT_MS = 130_000;

export const greetingVariantsApi = {
  /** KAN-752: без operatorId - все видимые варианты, с ним - варианты одного оператора. */
  list: async (operatorId?: string): Promise<GreetingVariant[]> =>
    (await apiClient.get(BASE, { params: operatorId ? { operator_id: operatorId } : undefined }))
      .data,
  create: async (data: {
    brief: string;
    enabled?: boolean;
    operator_id?: string;
  }): Promise<GreetingVariant> => (await apiClient.post(BASE, data)).data,
  update: async (
    id: number,
    data: { brief?: string; enabled?: boolean }
  ): Promise<GreetingVariant> => (await apiClient.patch(`${BASE}${id}/`, data)).data,
  remove: async (id: number): Promise<void> => {
    await apiClient.delete(`${BASE}${id}/`);
  },
  generate: async (id: number, n: number): Promise<GenerateResult> =>
    (await apiClient.post(`${BASE}${id}/generate/`, { n }, { timeout: GENERATE_TIMEOUT_MS }))
      .data,
  updateText: async (
    id: number,
    data: { text?: string; enabled?: boolean }
  ): Promise<GreetingText> =>
    (await apiClient.patch(`/api/v1/telegram/greeting-texts/${id}/`, data)).data,
  removeText: async (id: number): Promise<void> => {
    await apiClient.delete(`/api/v1/telegram/greeting-texts/${id}/`);
  },
};

export default greetingVariantsApi;
